module.exports = __webpack_public_path__ + "media/item04.d08d75b7.webm";